import React, { useState, useEffect } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import Aside from "../../../components/Aside";
import Api from "../../../services/api";
import moment from "moment";
import "moment/locale/pt-br";
import BtnStatusCloudbeds from "../../../components/BtnStatusCloudbeds";
import ConfirmacaoEnvioNota from "./confirmacao";
import ReactTooltip from "react-tooltip";

export default function SincronizacaoCloudBedsa() {
  const [loading, setLoading] = useState(false);
  const Loader = () => <div className="loading"></div>;
  const [reservas, setReservas] = useState({
    data: [],
    reservasInexistentes: [],
  });
  const [checkOutFrom, setCheckOutFrom] = useState(
    moment().format("YYYY-MM-DD"),
  );
  const [selectedReservations, setSelectedReservations] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [openModalConfirmacao, setOpenModalConfirmacao] = useState(false);
  const [reservaData, setReservaData] = useState([]);
  const propertyIDs = [2033, 213236, 315853];

  useEffect(() => {
    loadCloudBedsReservations(propertyIDs, checkOutFrom);
  }, []);

  async function loadCloudBedsReservations(propertyIDs, date) {
    setLoading(true);

    try {
      // Criando todas as chamadas de API simultaneamente
      const requests = propertyIDs.map((propertyID) =>
        Api.post("/motorreservas/cloubBedsReservationsCheckout", {
          propertyID,
          checkOutFrom: date,
        }),
      );

      // Executando todas as chamadas ao mesmo tempo
      const responses = await Promise.all(requests);
      const allReservas = responses.map((res) => res.data);

      // Unindo os dados de todas as propriedades
      const mergedData = {
        data: allReservas.flatMap((res) => res.data), // Mescla todas as reservas
        reservasInexistentes: allReservas.flatMap(
          (res) => res.reservasInexistentes || [],
        ), // Mescla reservas inexistentes
        count: allReservas.reduce((acc, res) => acc + (res.count || 0), 0), // Soma o total de reservas
      };
      console.log("mergedData", mergedData);
      setReservas(mergedData);
    } catch (error) {
      console.error("Ops! Ocorreu um erro", error);
    } finally {
      setLoading(false);
    }
  }

  async function loadReservation(reservationID, propertyID) {
    setLoading(true);

    let data = {
      reservationID: reservationID,
      propertyID: propertyID,
    };

    Api.post("/motorreservas/cloubBedsReservation", data)
      .then((response) => {
        console.log("response.data", response.data);
        if (response.data.success) {
          console.log("reserva", response.data.data);
          setReservaData(response.data.data);
          setOpenModalConfirmacao(true);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {});
  }

  function handleCheckboxChange(reservationID, propertyID) {
    setSelectedReservations((prev) => {
      const exists = prev.find((item) => item.reservationID === reservationID);
      return exists
        ? prev.filter((item) => item.reservationID !== reservationID)
        : [...prev, { reservationID, propertyID }];
    });
  }

  function synchronizeReservations() {
    console.log("Sincronizando as reservas: ", selectedReservations);
  }

  function renderTopPage() {
    return (
      <div className="top">
        <div>
          <span className="text">
            Emissão de Nota Fiscal
            <br />
            Check-out em
            {" " + moment(checkOutFrom).format("DD/MM/YY")}
            {/* ({reservas.count || 0}) */}
          </span>
        </div>
        <div>
          <div className="actions top">
            {selectedReservations.length > 0 && (
              <button onClick={synchronizeReservations} className="sincronizar">
                Emitir notas fiscais
              </button>
            )}
            <input
              type="date"
              name="date"
              value={checkOutFrom}
              onChange={(e) => {
                setCheckOutFrom(e.target.value);
                loadCloudBedsReservations(propertyIDs, e.target.value);
                setSelectedReservations([]);
              }}
            />
          </div>
        </div>
      </div>
    );
  }

  const RenderContent = () => {
    useEffect(() => {
      ReactTooltip.rebuild();
    });

    return (
      <>
        <table className="fontsize14">
          <thead>
            <tr>
              <th>
                <span>Unidade</span>
              </th>
              <th>
                <span>Id cloudbeds</span>
              </th>
              <th>
                <span>Titular da reserva</span>
              </th>
              <th>
                <span>Check-in</span>
              </th>
              <th>
                <span>Check-out</span>
              </th>
              <th>
                <span>Origem</span>
              </th>
              <th>
                <span>Criada em:</span>
              </th>
              <th>
                <span>Status</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {reservas.data.map((reserva, index) => {
              const unidade =
                reserva.propertyID === "2033"
                  ? "Hostel da Vila"
                  : reserva.propertyID === "213236"
                    ? "Vilarejo Suítes"
                    : "Albatroz";

              const reservaInexistente = reservas.reservasInexistentes.includes(
                reserva.reservationID,
              );

              return (
                <tr key={index} className="item">
                  <td>{unidade}</td>
                  <td
                    // style={{
                    //   backgroundColor: reservaInexistente
                    //     ? "red"
                    //     : "transparent",
                    // }}
                    onClick={() => {
                      setOpenModalConfirmacao(true);
                    }}
                  >
                    {reserva.reservationID}
                  </td>
                  <td>{reserva.guestName}</td>
                  <td>{moment(reserva.startDate).format("DD/MM/YY")}</td>
                  <td>{moment(reserva.endDate).format("DD/MM/YY")}</td>
                  <td>{reserva.sourceName}</td>
                  <td>{moment(reserva.dateCreated).format("DD/MM/YY")}</td>
                  <td>
                    <BtnStatusCloudbeds
                      status_nome={reserva.status}
                      status={reserva.status}
                      jsoncloudbeds_error={reserva.jsoncloudbeds_error}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </>
    );
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <ReactTooltip effect="solid" />
      <div className="container-box">
        <Aside />
        <main>
          {renderTopPage()}
          {reservas.data && RenderContent()}
        </main>
      </div>

      <Modal
        open={openModalConfirmacao}
        onClose={() => {
          setOpenModalConfirmacao(false);
        }}
        classNames={{
          overlay: "customOverlay",
          modal: "customModal50",
        }}
      >
        <ConfirmacaoEnvioNota
          reservaData={reservaData}
          setOpenModalConfirmacao={setOpenModalConfirmacao}
        />
      </Modal>
    </>
  );
}
